import createReducer from './createReducer';
import plain from './structure/plain';

export default createReducer(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/reducer.js
// module id = 891
// module chunks = 58